import React from 'react'
import { inject } from 'mobx-react'
import { languages } from '../../constants'
import { withTranslation } from 'react-i18next'
import classnames from 'classnames'

function Language ({ uiStore, i18n, menuRef }) {
  const handleActiveLangClick = (lang) => {
    uiStore.setActiveLang(lang)
    i18n.changeLanguage(lang.COUNTRY_CODE)
    localStorage.setItem('activeLang', lang.COUNTRY_CODE)
    document.body.dir = i18n.dir()
    uiStore.closeToolbarMenu()
    setTimeout(() => {
      if (menuRef && menuRef.current) {
        uiStore.menuWidth = menuRef.current.getBoundingClientRect().width
      }
    }, 0)
  }

  return (
    <div className='language-dropdown-menu'>
      {languages.map(lang => (
        <button
          type='button'
          className={classnames('language-item', { 'language-item--active': lang.NAME === uiStore.activeLang.NAME })}
          key={lang.NAME}
          onClick={() => handleActiveLangClick(lang)}
        >
          <img className='language-image' src={lang.FLAG} width='20' height='13' alt={`${lang.NAME} flag`} />
          <span className='language-name'>{lang.NAME}</span>
        </button>
      ))}
    </div>
  )
}

export default inject('uiStore')(withTranslation()(Language))
